import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class SpinnerComponent {
  @Input() center = false;
  @Input() alignMiddle = false;
  @Input() size?: number;

  currentClasses: Record<string, boolean> = {};
}
